
            <app-type-autres-infosATTR [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled"
                [autresInformations]="attributionFromMAPA.autresInformations"></app-type-autres-infosATTR>
    